<template>
    <div>
        <template v-if="data.loading.isLoading">
            <Skeleton></Skeleton>
        </template>
        <template v-else>
            <template v-for="changeLog in data.changeLogPage.data" :key="changeLog[1].id">
                <Comment v-if="mapping(changeLog[0]).length > 0">
                    <template v-slot:author>
                        <a>{{ changeLog[1].fullName || changeLog[1].username }}</a>
                    </template>
                    <template v-slot:content>
                        <template v-for="map in mapping(changeLog[0])" :key="map.key">
                            <div>
                                <b>{{ map.label?.() || map.inputProp?.({ field: map })?.text?.() }}: </b>
                                <template v-if="Array.isArray(map.value)">
                                    <template v-for="(changeLogChildren, index) in map.value" :key="index">
                                        <div>
                                            <span>[{{ $t(`components.changeLog.type.${changeLogChildren[2]}`) }}]</span>
                                            <p class="ml-2">
                                                {{
                                                    getValue({
                                                        value: map.changeLog?.getValueChildren
                                                            ? map.changeLog.getValueChildren({ record: changeLogChildren[0] })
                                                            : lodash.get(changeLogChildren[0], map.changeLog?.childrenKey)
                                                    })
                                                }}
                                            </p>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <span>{{ getValue({ value: map.value }) }}</span>
                                </template>
                            </div>
                        </template>
                    </template>
                    <template v-slot:datetime>
                        <Tooltip :title="moment(changeLog[1].revisionDate).fromNow()">
                            <span>{{ dateFormat({ text: changeLog[1].revisionDate, format: "DD/MM/YYYY HH:mm:ss" }) }}</span>
                        </Tooltip>
                    </template>
                </Comment>
            </template>
            <!-- <Pagination class="ml-auto" v-bind="pagination"></Pagination> -->
        </template>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "vue";
import moment from "moment";
import { Comment, Tooltip/*, Pagination */, Skeleton } from "ant-design-vue";
import lodash from "lodash";
import { createOnCallChangeLog, createMapping, createPagination, getValue } from "./change-log.logic";
import { createLoading } from "../../utils/loading";
import { dateFormat } from "../../utils/date";

export default defineComponent({
    components: {
        Comment,
        Tooltip,
        //Pagination,
        Skeleton
    },
    props: {
        id: {},
        onCallChangeLog: {},
        mappings: {}
    },
    setup(props) {
        const data = reactive({
            loading: createLoading(),
            changeLogPage: {
                page: 0,
                size: 5,
                totalPage: 1,
                totalSize: 0,
                data: []
            }
        });
        const onCallChangeLog = createOnCallChangeLog({ props, data });
        const mapping = createMapping({ props });
        const pagination = computed(() => createPagination({ data, onCallChangeLog, mapping }));
        onCallChangeLog();
        return { moment, data, mapping, lodash, pagination, dateFormat, getValue };
    }
});
</script>
